import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { ddados } from '../imprimirSolicitacao.ddados';
import DDadosItem from '@common/components/ddados/ddados.item';
import { connect } from '@common/components/base.component';
import imprimirSolicitacaoSelector from '../store/imprimirSolicitacao.selectors';
import imprimirSolicitacaoActions from '../store/imprimirSolicitacao.actions';
import Form from '@common/externos/components/validation/form.validation';
import RecaptchaModal from 'react-recaptcha';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  verifyCallback(response) {
    this.props.imprimirSolicitacaoActions.setTokenRecaptchaModal(response);
  }

  expiredCallback() {
    this.props.imprimirSolicitacaoActions.setTokenRecaptchaModal('');
  }

  recaptchaRef(ref) {
    this.props.imprimirSolicitacaoActions.setRecaptchaResetRefModal(ref?.reset);
  }

  onSubmit(data) {
    this.props.imprimirSolicitacaoActions.pesquisarImprimirSolicitacaoModal(data.CpfCnpj);
  }

  toggleModal() {
    this.props.imprimirSolicitacaoActions.toggleModalImprimirSolicitacao();
  }

  render() {
    const { Campos } = ddados;
    const { show } = this.props;

    return (
      <Modal
        className={'mt-5 mb-5'}
        show={show}
        onHide={this.toggleModal}
        enforceFocus={true}
        size="lg"
        backdrop="static"
      >
        <Form onSearchSubmit={this.onSubmit} onCancel={this.toggleModal} fromModal={true}>
          {() => (
            <div elementID="2">
              <Modal.Header>
                <Modal.Title>
                  <h3>Imprimir Solicitação</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col>
                    <DDadosItem name="CpfCnpj" {...Campos.CpfCnpj} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={4}>
                    <RecaptchaModal
                      elementID="2"
                      ref={this.recaptchaRef}
                      sitekey={'6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh'}
                      verifyCallback={this.verifyCallback}
                      render={'explicit'}
                      expiredCallback={this.expiredCallback}
                      hl="pt-br"
                      theme="light"
                      size="normal"
                    />
                  </Col>
                </Row>
              </Modal.Body>
            </div>
          )}
        </Form>
      </Modal>
    );
  }
}

export default connect({
  actions: {
    imprimirSolicitacaoActions,
  },
  selectors: {
    imprimirSolicitacaoSelector,
  },
})(Container);
